import { cn } from "@/lib/utils";

export default function InputError({
  error,
  className,
}: {
  error?: string;
  className?: string;
}) {
  if (!error) return null;
  return (
    <p
      className={cn(
        "dark:text-red-400 text-red-600 leading-tight text-xs",
        className
      )}
    >
      {error}
    </p>
  );
}
